/**
 * @remarks Reviewers should confirm loading, error, and i18n paths when modifying this file.
 * @remarks Contributors should run client tests and production build before opening a PR.
 * @see Sonar quality gate — maintain comment density and low cyclomatic complexity.
 */
/**
 * @description Maintainability notes for Sonar and future contributors:
 * - Prefer small functions and hooks over monolithic components.
 * - Extract shared literals, styles, and helpers instead of copying blocks.
 * - Document non-obvious business rules with short comments or JSDoc tags.
 * - Keep API access in logic/ modules; keep UI state in hooks/components.
 * - Use stable React keys and memoized handlers in list-heavy views.
 * - Add or update unit tests when changing conditional flows or payments.
 */
/**
 * @fileoverview Constants and react-select styles for appointment registration certifications.
 * @module utils/certificationSectionUtils
 */

/** Number of certification checkboxes shown per row on desktop layouts. */
export const CERTIFICATIONS_ITEMS_PER_ROW = 4;

/** Sector experience columns when the certifications section renders in tablet mode. */
export const SECTOR_EXPERIENCE_TABLET_COLUMNS = 2;

/** Sector experience columns when the certifications section renders in desktop mode. */
export const SECTOR_EXPERIENCE_DESKTOP_COLUMNS = 4;

/** Desktop layout styles for sector experience dropdowns in Certifications. */
export const SECTOR_EXPERIENCE_DESKTOP_SELECT_STYLES = {
  control: (baseStyles) => ({
    ...baseStyles,
    borderRadius: "8px",
    fontSize: "14px",
    cursor: "pointer",
    borderColor: baseStyles.borderColor,
    marginBottom: "-10px",
    width: "300px",
  }),
  container: (baseStyles) => ({
    ...baseStyles,
  }),
  valueContainer: (baseStyles) => ({
    ...baseStyles,
  }),
  input: (baseStyles) => ({
    ...baseStyles,
  }),
  option: (baseStyles) => ({
    ...baseStyles,
    cursor: "pointer",
  }),
  indicatorSeparator: () => ({ display: "none" }),
};
